import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientDetailComponent } from './client-detail/client-detail.component';
import { SharedModule } from '../shared/shared/shared.module';
import { ClientService } from './client.service';
import { EditClientModalComponent } from './edit-client-modal/edit-client-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClientDetailUsersComponent } from './client-detail/client-detail-users/client-detail-users.component';
import { ClientDetailMainComponent } from './client-detail/client-detail-main/client-detail-main.component';
import { UsersSharedModule } from '../users/shared/users-shared.module';
import { EditUserModalComponent } from '../users/shared/edit-user-modal/edit-user-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UsersSharedModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  providers: [
    ClientService
  ],
  entryComponents: [
    EditClientModalComponent
  ],
  declarations: [
    ClientListComponent,
    ClientDetailComponent,
    EditClientModalComponent,
    ClientDetailUsersComponent,
    ClientDetailMainComponent
  ]
})
export class ClientsModule {
}



// WEBPACK FOOTER //
// ./src/app/clients/clients.module.ts